import { DateTime } from 'luxon';
import { useContainer, useHttpDeleteSubmissionIntervalForMonth, useHttpGetSubmissionIntervalsForMonth } from '../../../hooks';
import { TimeLogUserSummaryWithUserInfoDto } from '../../../commonTypes/acs';
import { useTranslation } from '../../../hooks/useTranslation';
import { ToastStateHandler } from '../../../api';
import { Button } from '../../Common';

interface IDeleteSubmissionInterval {
    summary: TimeLogUserSummaryWithUserInfoDto;
    projectId: string;
    startDate: string;
    endDate: string;
    closeModal: () => void;
    onSuccessCallback?: () => void;
}

const DeleteSubmissionInterval = ({ summary, projectId, startDate, closeModal, onSuccessCallback }: IDeleteSubmissionInterval) => {
    const { t } = useTranslation();
    const toastHandler = useContainer(ToastStateHandler);

    const date = DateTime.fromISO(startDate);
    const { data: submissionIntervals } = useHttpGetSubmissionIntervalsForMonth({
        userSub: summary.userSub,
        projectId,
        month: date.toFormat('MMM'),
        year: date.year,
    });

    const { exec: deleteSubmissionIntervalForMonth } = useHttpDeleteSubmissionIntervalForMonth();

    const updateSummaryAfterHoursUnsubmission = () => {
        if (onSuccessCallback) {
            onSuccessCallback();
        }

        toastHandler.push(
            'success',
            t('newNotifications.timelog.timesheetSubmissionTitle'),
            t('newNotifications.timelog.timesheetUnsubmissionSuccess')
        );

        closeModal();
    };

    const deleteSubmissionIntervalCb = () => {
        if (submissionIntervals && submissionIntervals.length > 0) {
            const interval = submissionIntervals[0];
            const intervalDate = DateTime.fromISO(interval.startDate);
            deleteSubmissionIntervalForMonth(
                {
                    id: interval.id,
                    month: intervalDate.toFormat('MMM'),
                    year: intervalDate.year,
                },
                updateSummaryAfterHoursUnsubmission
            );
        }
    };

    return (
        <div className="delete-submission-interval">
            <h3 className="delete-submission-interval__headline">{t('clientTimeSheets.unsubmitModalTitle')}</h3>
            <p className="delete-submission-interval__description">Are you sure that you want to unsubmit hours for {date.toFormat('MMMM yyyy')}?</p>
            <div className="delete-submission-interval__action">
                <Button text={t('common.cancel')} onClick={closeModal} variant="text" color="blue" />
                <Button text={t('clientTimeSheets.unsubmit')} onClick={deleteSubmissionIntervalCb} />
            </div>
        </div>
    );
};

export default DeleteSubmissionInterval;
